<template>
  <div class="cntnt">
    <div id="customerCare" class="section-content customer-care-section">

      <!-- Centralized Care Banner -->
      <div  class="flyer" style="display: flex; align-items: flex-start;">
        <img src="../assets/call-center.png" alt="Call Center" style="width: 50px; height: 65px; margin-right: 4px;">
        <div style="line-height: 1.1; font-size: 16.5px;">
          <div>
            Centralized Customer Care Number:
            <strong style="color: #FFD700;font-size: 18px;">1912</strong>
          </div>
          <div>
            কেন্দ্ৰীয় গ্ৰাহক সেৱা নম্বৰ:
            <strong style="color: #FFD700;">১৯১২</strong>
          </div>
        </div>
      </div>

      <b-row>
        <b-col cols="12">
          <h1 class="heading">APDCL Customer Care</h1>
        </b-col>
      </b-row>

      <p class="content" style="text-align:left; font-size:1rem; color:#333;">
        <strong>For any Complaint or Query:</strong><br><br>
        <img src="../assets/call-center.png" style="height:1.5rem;width:1.5rem;vertical-align:middle;" />
        <strong>Contact / Complaint Number:</strong>
        <span class="contactTextStyle" style="color:#d32f2f;"> 1912</span>
        (Calls made from within Assam) or
        <span class="contactTextStyle" style="color:#d32f2f; font-weight:bold;">
        0361–3126201 / 0361-2803200
        </span>
        (Calls made from outside Assam)
        <br>
        <img src="../assets/whatsapp.png" style="height:1.5rem;width:1.5rem;vertical-align:middle;" />
        <strong>WhatsApp Number:</strong>
        <span class="contactTextStyle" style="color:#388e3c; font-weight:bold;"> 7575999666 </span>
        <br>
        <b-icon icon="envelope-fill" style="font-size:1.2rem; vertical-align:middle; margin-right:0.25rem;" />
        <strong>E-mail:</strong>
        <span class="contactTextStyle" style="color:#388e3c; font-weight:bold;"> support@apdcl.org </span>
        <br>
        <small style="display:block; margin-top:0.5rem; font-style:italic; color:#555;">
          (For billing-related complaints, please provide your consumer number and subdivision name)
        </small>
      </p>
    </div>

    <!-- Key Officials -->
    <div id="kofficial" class="section-content" style="display: none; overflow-y: auto; max-height: 70vh;">
      <b-row>
        <b-col cols="12">
          <h1 class="heading">Key Officials Guwahati/Head Quarter (Bijulee Bhawan)</h1>
        </b-col>
      </b-row>
      <p class="content">
        <b-table responsive bordered striped :items="getKeyOfficial" :fields="KeOfficialfields" />
      </p>
    </div>

    <!-- Zone Contact -->
    <div id="zone" class="section-content" style="display: none; overflow-y: auto; max-height: 70vh;">
      <b-row>
        <b-col cols="12">
          <h1 class="heading">Field Office:<span class="zone-text">Zone Contact Details</span></h1>
        </b-col>
      </b-row>
      <p class="content">
        <b-table responsive bordered striped :items="getZoneData" :fields="Zonefields" />
      </p>
    </div>

    <!-- Circle Contact -->
    <div id="circle" class="section-content" style="display: none; overflow-y: auto; max-height: 70vh;">
      <b-row>
        <b-col cols="12">
          <h1 class="heading">Field Office:<span class="zone-text">Circle Contact Details</span></h1>
        </b-col>
      </b-row>
      <p class="content">
        <b-table responsive bordered striped :items="getCircleContact" :fields="Circlefields">
          <template v-slot:cell(email)="data">
            <span v-html="data.value"></span>
          </template>
        </b-table>
      </p>
    </div>

    <!-- Division Contact -->
    <div id="division" class="section-content" style="display: none; overflow-y: auto; max-height: 70vh;">
      <b-row>
        <b-col cols="12">
          <h1 class="heading">Field Office:<span class="zone-text">Division Contact Details</span></h1>
        </b-col>
      </b-row>
      <p class="content">
        <b-table responsive bordered striped :items="getDivisionContact" :fields="Divisionfields" />
      </p>
    </div>

    <!-- Sub-Division Contact -->
    <div id="subdivision" class="section-content" style="display: none; overflow-y: auto; max-height: 70vh;">
      <b-row>
        <b-col cols="12">
          <h1 class="heading">Field Office:<span class="zone-text">Sub-Division Contact Details</span></h1>
        </b-col>
      </b-row>
      <p class="content">
        <b-table responsive bordered striped :items="getSubDivContact" :fields="SubDivisionfields" />
      </p>
    </div>

    <!-- IRCA Contact -->
    <div id="irca" class="section-content" style="display: none; overflow-y: auto; max-height: 70vh;">
      <b-row>
        <b-col cols="12">
          <h1 class="heading">
            Field Office:<span class="zone-text">IRCA Contact Details<br>(Industrial Revenue Collection Area)</span>
          </h1>
        </b-col>
      </b-row>
      <p class="content">
        <b-table responsive bordered striped :items="getIRCAContact" :fields="Ircafields" />
      </p>
    </div>

    <!-- T&C Contact -->
    <div id="tc" class="section-content" style="display: none; overflow-y: auto; max-height: 70vh;">
      <b-row>
        <b-col cols="12">
          <h1 class="heading">Field Office:<span class="zone-text">T&C Contact Details</span></h1>
        </b-col>
      </b-row>
      <p class="content">
        <b-table responsive bordered striped :items="getTCContact" :fields="TCfields" />
      </p>
    </div>

    <!-- AGM Contact -->
    <div id="agm" class="section-content" style="display: none; overflow-y: auto; max-height: 70vh;">
      <b-row>
        <b-col cols="12">
          <h1 class="heading">District-wise AGM(Project) Contact Details</h1>
        </b-col>
      </b-row>
      <p class="content">
        <b-table responsive bordered striped :items="getAgmContact" :fields="Agmfields" />
      </p>
    </div>
  </div>
</template>



<script>
import { mapGetters, mapActions } from 'vuex'
// import * as pdfMake from 'pdfmake/build/pdfmake';
// import * as pdfFonts from 'pdfmake/build/vfs_fonts';
// pdfMake.vfs = pdfFonts.pdfMake.vfs;

var thColor = '#0288d1';

export default {

  data() {
      return {
        show:false,
        KeOfficialfields: [
          { key: 'contact_person', label: 'Name',thStyle: {width: '25vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'designation', label: 'Designation',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'phone', label: 'Phone',thStyle: {width: '25vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'mobile', label: 'Mobile',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'email', label: 'Email',thStyle: {width: '15vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }
        ],
        Zonefields: [
          { key: 'zone_name', label: 'Zone',thStyle: {width: '15vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'contact_person', label: 'Contact Person',thStyle: {width: '25vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'designation', label: 'Designation',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
            { key: 'mobile', label: 'Mobile',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'email', label: 'Email',thStyle: {width: '15vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }
          ],
        Circlefields: [
          { key: 'zone_name', label: 'Zone',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'circle_name', label: 'Circle',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'contact_person', label: 'Contact Person',thStyle: {width: '25vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'phone', label: 'Phone',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'mobile', label: 'Mobile',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'email', label: 'Email',thStyle: {width: '15vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }
        ],
        Divisionfields: [
          { key: 'circle_name', label: 'Circle',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'division_name', label: 'Division',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'contact_person', label: 'Contact Person',thStyle: {width: '30vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'phone', label: 'Phone',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'mobile', label: 'Mobile',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'email', label: 'Email',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }
        ],
        SubDivisionfields: [
          { key: 'circle_name', label: 'Circle',thStyle: {width: '8vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'division_name', label: 'Division',thStyle: {width: '8vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'sd_name', label: 'Sub-Division',thStyle: {width: '8vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'contact_person', label: 'Contact Person',thStyle: {width: '30vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'mobile', label: 'Mobile',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'email', label: 'Email',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }
        ],
        Ircafields: [
          { key: 'irca_name', label: 'Name',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'contact_person', label: 'Contact Person',thStyle: {width: '30vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'mobile', label: 'Mobile',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'email', label: 'Email',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }
      ],
      TCfields: [
        { key: 'tc_name', label: 'Name',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'contact_person', label: 'Contact Person',thStyle: {width: '30vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'mobile', label: 'Mobile',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'email', label: 'Email',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }
      ],
      Agmfields: [
          { key: 'district', label: 'District',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'contact_person', label: 'Contact Person',thStyle: {width: '30vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'mobile', label: 'Mobile',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'email', label: 'Email',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }
      ]
      }
  },
  computed:
  {
    ...mapGetters([
      'getKeyOfficial',
      'getZoneData',
      'getCircleContact',
      'getDivisionContact',
      'getSubDivContact',
      'getIRCAContact',
      'getTCContact',
      'getAgmContact'
    ])

  },
  methods: {
    ...mapActions([
      'retrieveAllContact'
    ]),
  },
  beforeMount() {
  
      if(this.getKeyOfficial.length == 0) {
        this.retrieveAllContact();
     
      }
  }
}
</script>
<style scoped="true">
.heading {
  border-left: 10px solid #ed7c27;
  border-left-width: 10px;
  border-left-style: solid;
  border-left-color: rgb(237, 124, 39);
  font-size: 25px;
  text-align: left;
  letter-spacing: 1px;
  padding-left: 1rem;
  margin-bottom: 2rem;
  margin-top: 1rem;
  text-transform: capitalize;
}
.zone-text {
  color: #e3ac5a; 
}
.content{
  text-align: justify;
  line-height: 1.8rem;
  font-size: 0.9rem;
}
.cntnt {
  box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
  padding: 10px 30px 10px 30px;
  overflow-y: auto;
  max-height: calc(100vh - 120px); /* Adjust 120px as needed based on your header */
  -webkit-overflow-scrolling: touch; /* for smooth scroll on iOS */
}
.customer-care-section {
  display: block;
  overflow-y: auto;
  max-height: 70vh;
  position: relative;
  background-color: #f9f9f9;
  border-radius: 10px;
  padding: 1rem;
}

.flyer{
  font-family: Arial, sans-serif;
  max-width: 350px;
  background: #007BFF;
  color: #fff;
  padding: 10px;
  border-radius: 5px;
  float: right;
  margin: 1rem;
  text-align: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}



table{
  text-align: left !important;
}
.contactTextStyle{
    text-shadow: 1.5px 0px 1px grey;
    font-size:1.2rem;
    font-weight:700;
    color:#03a9f4;
    letter-spacing:2px;
  }

@media (max-width: 768px) {
  .cntnt{
    box-shadow: none;
    padding:10px 30px 10px 30px;
  }
  .flyer {
    float: none;
    margin: 1rem auto;
  }
   #kofficial{
    max-height:50vh !important;
   }
   #zone{
    max-height:50vh !important;
   }
   #circle{
    max-height:50vh !important;
   }
   #division{
    max-height:50vh !important;
   }
   #subdivision{
    max-height:50vh !important;
   }
   #irca{
    max-height:50vh !important;
   }
   #tc{
    max-height:50vh !important;
   }
   #agm{
    max-height:50vh !important;
   }
  }
@media (max-width: 576px) {
  .flyer{
    width: 100%;
    max-width: 90%;
    margin: 1rem auto;
    font-size: 0.95rem;
  }
  .flyer strong {
    font-size: 1.3rem !important;
  }
  #kofficial{
    max-height:50vh !important;
   }
  #zone{
    max-height:50vh !important;
  }
  #circle{
   max-height:50vh !important;
  }
  #division{
   max-height:50vh !important;
  }
  #subdivision{
    max-height:50vh !important;
  }
  #irca{
    max-height:50vh !important;
  }
  #tc{
    max-height:50vh !important;
  }
  #agm{
    max-height:50vh !important;
  }
}
  
</style>